var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-loading',{attrs:{"type":"spiningDubbles","color":"white","size":{ width: '40px', height: '40px' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }